import { useState, useEffect } from 'react';
import Cookies from 'js-cookie';

export function useProductSelection({ selectedProductId, activeProducts = [], legacyProducts = [] }) {
    const allProducts = [...activeProducts, ...legacyProducts];
    const getProductFromId = (id) => allProducts.find(x => x.value === Number(id));

    const [selectedProduct, setSelectedProduct] = useState(() => getProductFromId(selectedProductId));

    const setProductById = (id) => {
        if (id) {
            Cookies.set('selected_product', id);
        } else {
            Cookies.remove('selected_product');
        }

        setSelectedProduct(getProductFromId(id));
    };

    // Handle initial state and update on selectedProductId change
    useEffect(() => {
        setSelectedProduct(getProductFromId(selectedProductId));
    }, [selectedProductId]); // Add dependencies

    return { selectedProduct, setProductById };
}

export const getSelectedProductIdFromCookie = () => {
    return Cookies.get("selected_product");
}

export const clearProductCookieSelection = () => {
    Cookies.remove('selected_product');
};

export const setGetArguments = (url, selectedProductId) => {
    const _url = new URL(url, "https://dummy.url");

    if (selectedProductId) {
        _url.searchParams.set("selected_product", selectedProductId);
    } else {
        _url.searchParams.delete("selected_product");
    }

    return _url.pathname + _url.search;
};
